import { useHead, useJsonld } from '#imports'
import { useGlobalStore } from '@/stores'
import type { ArticleNews } from '~/utils/types'

export default function useSeo(news?: ArticleNews) {
  const globalStore = useGlobalStore()

  const title = `${news?.seo?.meta_title || news?.subject}｜${import.meta.env.VITE_WEBSITE_TITLE}`
  const description = news?.seo?.meta_description
  const url = news?.seo?.canonical || `${import.meta.env.VITE_DOMAIN}/news/article/${news?.seo?.meta_slug || news?.id}`

  globalStore.setBreadcrumbs([
    { title: '最新消息', isActive: false },
    { title: news?.categories[0].seo?.meta_title || '', isActive: true }
  ])

  useSeoMeta({
    title: title,
    ogTitle: title,
    description: description,
    ogDescription: description,
    ogImage: news?.seo?.og_image?.link,
    keywords: news?.seo?.meta_keywords?.join(',')
  })

  let meta = []
  if (!news?.status) {
    meta.push({ hid: 'robots', name: 'robots', content: 'noindex' })
  }

  useHead({
    link: [
      {
        rel: 'canonical',
        href: url
      }
    ],
    meta: meta
  })

  useJsonld({
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: '首頁',
            item: import.meta.env.VITE_DOMAIN
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: '最新消息',
            item: `${import.meta.env.VITE_DOMAIN}/news`
          },
          {
            '@type': 'ListItem',
            position: 3,
            name: news?.categories[0].seo?.meta_title,
            item: `${import.meta.env.VITE_DOMAIN}/news/${news?.categories[0].seo?.meta_slug || news?.categories[0].id}`
          },
          {
            '@type': 'ListItem',
            position: 4,
            name: news?.seo?.meta_title,
            item: url
          }
        ]
      }
    ]
  })
}
